<template>
  <div class="card">
    <div class="card-body" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <form @submit="submit" class="add-edit-form product-form">
              <div class="row">
                <div class="col">
                  <label for="" class="checkbox-icon">
                    <span class="text-left">Enabled:</span>
                    <label class="checkbox-container">
                      <input v-model="model.is_enabled" checked type="checkbox">
                      <span class="checkmark"></span>
                    </label>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div v-for="field in inputFields" :key="field.key">
                    <label for v-if="field.type === 'select'">
                      <span>{{ field.label }}:</span>
                      <select class="form-control" v-model="model[field.key]">
                        <option selected="selected" hidden="hidden" value="">Select Category</option>
                        <option v-for="option in field.options" :key="option.id" :value="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                    </label>
                    <label for v-else>
                      <span>{{ field.label }}:</span>
                      <input v-model="model[field.key]" :type="field.type" :placeholder="field.placeholder" class="form-control" />
                    </label>
                  </div>
                  <input-file-field label="Thumbnail" index="thumbnail" :model="model" />
                </div>
                <div class="col-lg-6">
                  <div
                    class="thumbnail-display"
                    :style='{ backgroundImage: "url(" + model.thumbnailUrl + ")", }'
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-6" v-for="field in formatFields" :key="field.key">
                  <input-file-field
                    :label="field.label"
                    :model="model"
                    :index="field.key"
                  />
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters[this.apiBaseUrl + '/apiLoading']" class="btn btn-success">
                  <div v-if="!this.$store.getters[this.apiBaseUrl + '/apiLoading']">{{toEdit ? 'Update' : 'Save'}}</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
          <div class="col-lg-6"></div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import InputFileField from './InputFileField.vue'
/* eslint-disable no-undef */
export default{
  components: { InputFileField },
  name: 'AddEditForm',
  props: {
    model: { required: true, type: Object },
    fields: { required: true, type: Array },
    returnUrl: { required: true, type: String },
    apiBaseUrl: { required: true, type: String },
    toEdit: { required: true, type: Boolean }
  },
  data () {
    return { }
  },
  computed: {
    inputFields () {
      return this.fields.filter((field) => { return field.type !== 'format' })
    },
    formatFields () {
      return this.fields.filter((field) => { return field.type === 'format' })
    }
  },
  mounted () {
    $(document).on('change', '#thumbnail', function () {
      if (event.target.files.length) { $('.thumbnail-display').css('background-image', 'url(' + window.URL.createObjectURL(event.target.files[0]) + ')') } else { $('.thumbnail-display').css('background-image', 'none') }
    })
  },
  methods: {
    submit (event) {
      event.preventDefault()
      var functionName = '/post'
      if (this.toEdit) { functionName = '/patch' }
      this.$store.dispatch(this.apiBaseUrl + functionName, this.model.getFormData())
        .then(() => {
          this.$router.push(this.returnUrl)
          this.$toast.success('Operation successfull!')
        })
        .catch((err) => {
          console.log(err.response)
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 767px) {
  .cat-div {
    width: 100% !important;
  }
}
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AddEditForm.vue